import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ResponsiveEnums } from '@yodlee/common-components/dist/types/enumerations';
import { AvatarUtils, ErrorUtils } from '@yodlee/common-components/dist/utilities';
import { Avatar, Icon, Menu, Tooltip } from "antd";
import { ClickParam } from "antd/lib/menu";
import React, { useContext, useEffect, useState } from "react";
import { useMediaQuery } from 'react-responsive';
import { SVG } from "../../assets";
import { MenuConfigs, UrlConfigs } from "../../configurations";
import { ApplicationContext } from "../../context";
import { AmplitudeEventsUtils, DataUtils, HelpContentUtils } from '../../utilities';
import { getAuthenticationDetails } from "../../utilities/authentication";

const MenuItems: React.FC<any> = ({ history, isCollapsed, picture, setIsSplashOpen, toggleCollapsed, helpContentMap, userFeatures, brandproducts }) => {
    const isMD = useMediaQuery({ minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD });
    const [openKey, setOpenKey] = useState<any>([]);
    const [isOpenMyAccount, setIsOpenMyAccount] = useState(Boolean);
    const { permissions, onload } = useContext(ApplicationContext);

    useEffect(() => {
        if (isCollapsed) {
            setOpenKey([]);
        }
    }, [isCollapsed]);

    useEffect(() => {
        if (history.location.pathname === '/my-account') {
            setIsOpenMyAccount(true);
        }
    })

    const onOpenChange = (openKeys: any) => {
        const latestOpen = openKeys.find((key: any) => openKey.indexOf(key) === -1);
        setOpenKey([latestOpen]);
    }

    const legacyYccMenus = onload ? onload.menus.filter(menu => !["Log Out", "Profile Settings"].includes(menu.name)) : [];
    const MENU = MenuConfigs.SIDEBAR_MENU(permissions!, onload && (onload.user.role.name === "Admin" || onload.isSuperAdmin), onload && onload?.financialInstitution?.type?.id === 4, legacyYccMenus.length > 0, onload && onload.user?.supportPartner != undefined, userFeatures || [], brandproducts);

    const menuClick = (menu: ClickParam) => {
        //#Hack
        let tooltipElementsCollection = document.getElementsByClassName("ant-tooltip ant-menu-inline-collapsed-tooltip");
        let tooltipElements: Array<any> = Array.from(tooltipElementsCollection);

        AmplitudeEventsUtils.menuOpen(isCollapsed ? 'HOVER' : 'EXPAND', menu.key)

        for (let elem of tooltipElements) {
            const elemClassList = elem?.getAttribute("class");
            if (!elemClassList?.includes("ant-tooltip-hidden"))
                elem?.setAttribute("class", elemClassList + " ant-tooltip-hidden");
        }

        if (menu.key === UrlConfigs.ROUTES.SPLASH.url) {
            setIsSplashOpen(true);
            return;
        }
        if (menu.key === UrlConfigs.ROUTES.LEGACY_EXPERIENCE.url && onload) {
            const searchMenu = legacyYccMenus.find((menu: any) => menu.name === "Search");
            const url = searchMenu ? searchMenu.url : legacyYccMenus.length > 0 ? legacyYccMenus[0].url : undefined;

            if (url) {
                window.open(url, "_blank");
            }
            else {
                ErrorUtils.showErrorModal();
            }
            return;
        }
        if (menu.key === UrlConfigs.ROUTES.QUESTIONS.url) {
            const helpContentLinkDetails = HelpContentUtils.getHelpContentLinkDetails(helpContentMap, history.location.pathname);
            const { helpUrl, authReq, authUrl } = helpContentLinkDetails;
            if (authReq && authUrl) {
                const authentication = getAuthenticationDetails();
                DataUtils.helpContentAuthToken(authentication).get().then((token) => {
                    const jwtToken = token?.jwtToken;
                    HelpContentUtils.loadHelpContentWithAuth(helpUrl, authUrl, jwtToken);
                })
            } else {
                window.open(helpUrl, "_blank");
            }
            return;
        }
        if (menu.key === UrlConfigs.ROUTES.MY_ACCOUNT.url) {
            setIsOpenMyAccount(true);
        }
        else {
            setIsOpenMyAccount(false);
        }

        if (menu.key === UrlConfigs.ROUTES.MY_ACCOUNT.subRoutes.SIGN_OUT.url) {
            const logoutUrl = (onload?.menus || []).find((menu: any) => menu.name === "Log Out")?.url;
            if (logoutUrl) {
                window.location.href = logoutUrl;
            }
            return;
        }

        history.push(menu.key)
        !isCollapsed && toggleCollapsed('LAYOUT');
    }

    return (
        <Menu
            onClick={menuClick}
            openKeys={openKey}
            onOpenChange={onOpenChange}
            theme='light'
            mode='inline'
            forceSubMenuRender={false}
            selectedKeys={[!history.location.pathname || history.location.pathname === "/" ? "/dashboard" : history.location.pathname]}
            defaultSelectedKeys={[!history.location.pathname || history.location.pathname === "/" ? "/dashboard" : history.location.pathname]}>
            {
                Object.keys(MENU).map(menuType => {
                    return (
                        <Menu.ItemGroup
                            key={menuType}
                            {
                            ...menuType === 'BOTTOM' ? { style: { visibility: !isMD && isCollapsed ? 'hidden' : 'inherit', bottom: isMD ? '44px' : '0px', width: isCollapsed ? isMD ? '60px' : '0px' : '240px' } } :
                                { className: isCollapsed ? "custom-overflow-height-230-px" : "custom-overflow-height-330-px" }
                            }

                        >
                            {
                                (menuType === 'BOTTOM' ? MENU.BOTTOM : MENU.TOP).map(menuItem => {
                                    if (menuItem.subMenus) {
                                        return (
                                            <Menu.SubMenu
                                                popupClassName={`${menuType === 'BOTTOM' ? 'bottom-submenu-popup-top-align' : ''}`}
                                                onTitleClick={(e) => {
                                                    isCollapsed && toggleCollapsed('MENUITEM');
                                                    e.domEvent.stopPropagation(); e.domEvent.stopImmediatePropagation && e.domEvent.stopImmediatePropagation(); e.domEvent.preventDefault();
                                                }
                                                }
                                                key={menuItem.key}
                                                title={
                                                    <span className="label-1">
                                                        <Icon className="font-size-xl" style={{ width: "0px" }} component={() => menuItem.key === "internal-tools" ? <SVG.YodleeCustomersLogo /> : <FontAwesomeIcon icon={menuItem.icon!} />} />
                                                        {menuItem.name.length > 15 ? (
                                                            <Tooltip title={menuItem.name.toUpperCase()} placement="bottomLeft">
                                                                <span className="font-size-sm margin-left-md">{menuItem.name.toUpperCase()}</span>
                                                            </Tooltip>
                                                        ) : (
                                                            <span className="font-size-sm margin-left-md">{menuItem.name.toUpperCase()}</span>
                                                        )}
                                                    </span>
                                                }
                                            >
                                                {
                                                    menuItem.subMenus.map(subMenuItem =>
                                                        <Menu.Item onClick={(e) => { e.domEvent.stopPropagation(); e.domEvent.stopImmediatePropagation && e.domEvent.stopImmediatePropagation(); e.domEvent.preventDefault(); }} key={subMenuItem.url}>
                                                            {subMenuItem.name}
                                                        </Menu.Item>
                                                    )
                                                }
                                            </Menu.SubMenu>
                                        )
                                    }
                                    else {
                                        return (
                                            <Menu.Item onClick={(e) => { e.domEvent.stopPropagation(); e.domEvent.stopImmediatePropagation && e.domEvent.stopImmediatePropagation(); e.domEvent.preventDefault(); }} key={menuItem.url} className="padding-left-xl">
                                                <Icon
                                                    className="font-size-xl"
                                                    style={{ width: "0px" }}
                                                    component={() =>
                                                        menuItem.key === 'my-account' ?
                                                            <Avatar
                                                                size="default"
                                                                style={{
                                                                    left: "-9px",
                                                                    top: "-2px",
                                                                    fontSize: "12px",
                                                                    fontWeight: "bold",
                                                                    color: isOpenMyAccount ? AvatarUtils.getAvatarDetails(onload?.user).avatarColor : "white",
                                                                    background: isOpenMyAccount ? "white" : AvatarUtils.getAvatarDetails(onload?.user).avatarColor
                                                                }}
                                                                {...picture && { src: picture }}
                                                            >
                                                                {onload?.user && AvatarUtils.getAvatarDetails(onload?.user).shortName}
                                                            </Avatar> :
                                                            <FontAwesomeIcon icon={menuItem.icon!} />
                                                    }
                                                />
                                                {menuItem.name.length > 15 ? (
                                                    <Tooltip title={menuItem.name.toUpperCase()} placement="bottomLeft">
                                                        <span className="menu-title label-1 font-size-sm margin-left-md">
                                                            {menuItem.name.toUpperCase()}
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    <span className="menu-title label-1 font-size-sm margin-left-md">
                                                        {menuItem.name.toUpperCase()}
                                                    </span>
                                                )}
                                            </Menu.Item>
                                        )
                                    }
                                })
                            }
                        </Menu.ItemGroup>
                    )
                })
            }
        </Menu >
    )
}

export default MenuItems;